import ChartBarKPI from '@/components/KPI/ChartBarKPI.tsx';
import { ChartBarProps } from '@/components/KPI/ChartBar.tsx';
import { useEffect, useRef, useState } from 'react';
import { KTAccordion } from '@/metronic/core';
import {
  useGetKPIEvolution,
  useGetKPIEvolutionDamage,
  useGetKPIEvolutionElement,
  useGetKPIEvolutionElementDamageLink,
} from '@/hooks/ai.hooks.ts';
import { KpiFilterRequest } from '@/api/entities/kpi.ts';
import { Select } from '@/components/Controls/Select';
import { useGetModerationEquipments } from '@/hooks/equipment.hooks';
import { useGetModerationDamages } from '@/hooks/damage.hooks';
import { useTranslation } from 'react-i18next';
import Loader from '@/components/Loading/Loader';
import dayjs from 'dayjs';
import { DateTimePicker } from '@/components/Custom/DateTimePicker';
import { formatDayjsDate } from '@/utils/date.utils';

const initialKpiFilterRequest: KpiFilterRequest = {
  startDate: formatDayjsDate(dayjs()),
  endDate: formatDayjsDate(dayjs()),
  groupBy: 'month',
};

export default function EvolutionKPIMoteur() {
  const { t } = useTranslation('kpi');
  const [settings, setSettings] = useState<ChartBarProps>();
  const [settings2, setSettings2] = useState<ChartBarProps>();

  const [settings3, setSettings3] = useState<ChartBarProps>();
  const [settings4, setSettings4] = useState<ChartBarProps>();
  const [settings5, setSettings5] = useState<ChartBarProps>();
  const [settings6, setSettings6] = useState<ChartBarProps>();
  const [settings7, setSettings7] = useState<ChartBarProps>();

  const [settings8, setSettings8] = useState<ChartBarProps>();
  const [settings9, setSettings9] = useState<ChartBarProps>();
  const [settings10, setSettings10] = useState<ChartBarProps>();
  const [settings11, setSettings11] = useState<ChartBarProps>();
  const [settings12, setSettings12] = useState<ChartBarProps>();

  const [settings13, setSettings13] = useState<ChartBarProps>();
  const [settings14, setSettings14] = useState<ChartBarProps>();
  const [settings15, setSettings15] = useState<ChartBarProps>();
  const [settings16, setSettings16] = useState<ChartBarProps>();

  const [groupBy, setGroupBy] = useState<string>('month');
  const evolutionKpiGeneriques = useRef<HTMLDivElement>(null);
  const evolutionKpiGeneriquesItem = useRef<HTMLDivElement>(null);

  const [filters, setFilters] = useState<KpiFilterRequest>(
    initialKpiFilterRequest
  );
  const [filtersElement, setFiltersElement] = useState<KpiFilterRequest>(
    initialKpiFilterRequest
  );
  const [filtersDamage, setFiltersDamage] = useState<KpiFilterRequest>(
    initialKpiFilterRequest
  );
  const [filtersElementDamageLink, setFiltersElementDamageLink] =
    useState<KpiFilterRequest>(initialKpiFilterRequest);

  const { data, isLoading } = useGetKPIEvolution(filters);
  const { data: dataElements } = useGetKPIEvolutionElement(filtersElement);
  const { data: dataDamage } = useGetKPIEvolutionDamage(filtersDamage);
  const { data: dataElementDamageLink } = useGetKPIEvolutionElementDamageLink(
    filtersElementDamageLink
  );

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [totalPhotosModerate, setTotalPhotosModerate] = useState<number>(0);

  const { equipmentsSelectOptions } = useGetModerationEquipments();
  const { uniqueDamagesSelectOptions } = useGetModerationDamages();

  const optionElements = equipmentsSelectOptions;

  const optionsDmgList = uniqueDamagesSelectOptions;

  const [valueElement, setValueElement] = useState<string>();
  const [valueDamage, setValueDamage] = useState<string>();
  const [valueElementLink, setValueElementLink] = useState<string>();
  const [valueDamageLink, setValueDamageLink] = useState<string>();

  const moderatedPhotosText =
    totalPhotosModerate > 1
      ? t('moderatedPhotos').toLowerCase()
      : t('moderatedPhoto').toLowerCase();

  useEffect(() => {
    handleInitAccordion();
  }, []);

  useEffect(() => {
    setFiltersElement({
      ...filtersElement,
      target: valueElement,
    });
  }, [valueElement]);

  useEffect(() => {
    setFiltersDamage({
      ...filtersDamage,
      target: valueDamage,
    });
  }, [valueDamage]);

  useEffect(() => {
    setFiltersElementDamageLink({
      ...filtersElementDamageLink,
      targetEl: valueElementLink,
      targetDmg: valueDamageLink,
    });
  }, [valueElementLink, valueDamageLink]);

  useEffect(() => {
    const kpi = dataElementDamageLink?.data;
    if (kpi) {
      setSettings13({
        hiddenCategorieInLabel: true,
        showYaxis: true,
        data: kpi.totalElementDamageLinkWithoutTouching,
        colors: ['#FF8080', '#FEDD5A', '#7EE4AC', '#80C1FF'],
        categories: kpi.periodsElementDamageLinkWithoutTouching,
        dataLabelsPosition: 'top',
        dataLabelsTextAchor: 'end',
        height: 90 * kpi.periodsElementDamageLinkWithoutTouching.length,
      });
      setSettings14({
        hiddenCategorieInLabel: true,
        showYaxis: true,
        data: kpi.totalElementDamageLinkWithTouching,
        colors: ['#FF8080', '#FEDD5A', '#7EE4AC', '#80C1FF'],
        categories: kpi.periodsElementDamageLinkWithTouching,
        dataLabelsPosition: 'top',
        dataLabelsTextAchor: 'end',
        height: 90 * kpi.periodsElementDamageLinkWithTouching.length,
      });
      setSettings15({
        hiddenCategorieInLabel: true,
        showYaxis: true,
        data: kpi.totalElementDamageLinkNonDetections,
        colors: ['#FF8080', '#FEDD5A', '#7EE4AC', '#80C1FF'],
        categories: kpi.periodsElementDamageLinkNonDetections,
        dataLabelsPosition: 'top',
        dataLabelsTextAchor: 'end',
        height: 90 * kpi.periodsElementDamageLinkNonDetections.length,
      });
      setSettings16({
        hiddenCategorieInLabel: true,
        showYaxis: true,
        data: kpi.totalElementDamageLinkAttributionErrors,
        colors: ['#FF8080', '#FEDD5A', '#7EE4AC', '#80C1FF'],
        categories: kpi.periodsElementDamageLinkAttributionErrors,
        dataLabelsPosition: 'top',
        dataLabelsTextAchor: 'end',
        height: 90 * kpi.periodsElementDamageLinkAttributionErrors.length,
      });
    }
  }, [dataElementDamageLink]);

  useEffect(() => {
    const kpi = dataElements?.data;
    if (kpi) {
      setSettings3({
        hiddenCategorieInLabel: true,
        showYaxis: true,
        data: kpi.totalElementWithoutTouching,
        colors: ['#FF8080', '#FEDD5A', '#7EE4AC', '#80C1FF'],
        categories: kpi.periodsElementWithoutTouching,
        dataLabelsPosition: 'top',
        dataLabelsTextAchor: 'end',
        height: 90 * kpi.periodsElementWithoutTouching.length,
      });
      setSettings4({
        hiddenCategorieInLabel: true,
        showYaxis: true,
        data: kpi.totalElementWithTouching,
        colors: ['#FF8080', '#FEDD5A', '#7EE4AC', '#80C1FF'],
        categories: kpi.periodsElementWithTouching,
        dataLabelsPosition: 'top',
        dataLabelsTextAchor: 'end',
        height: 90 * kpi.periodsElementWithTouching.length,
      });
      setSettings5({
        hiddenCategorieInLabel: true,
        showYaxis: true,
        data: kpi.totalElementFalsePositive,
        colors: ['#FF8080', '#FEDD5A', '#7EE4AC', '#80C1FF'],
        categories: kpi.periodsElementFalsePositive,
        dataLabelsPosition: 'top',
        dataLabelsTextAchor: 'end',
        height: 90 * kpi.periodsElementFalsePositive.length,
      });
      setSettings6({
        hiddenCategorieInLabel: true,
        showYaxis: true,
        data: kpi.totalElementNonDetections,
        colors: ['#FF8080', '#FEDD5A', '#7EE4AC', '#80C1FF'],
        categories: kpi.periodsElementNonDetections,
        dataLabelsPosition: 'top',
        dataLabelsTextAchor: 'end',
        height: 90 * kpi.periodsElementNonDetections.length,
      });
      setSettings7({
        hiddenCategorieInLabel: true,
        showYaxis: true,
        data: kpi.totalElementAttributionErrors,
        colors: ['#FF8080', '#FEDD5A', '#7EE4AC', '#80C1FF'],
        categories: kpi.periodsElementAttributionErrors,
        dataLabelsPosition: 'top',
        dataLabelsTextAchor: 'end',
        height: 90 * kpi.periodsElementAttributionErrors.length,
      });
    }
  }, [dataElements]);

  useEffect(() => {
    const kpi = dataDamage?.data;
    if (kpi) {
      setSettings8({
        hiddenCategorieInLabel: true,
        showYaxis: true,
        data: kpi.totalDamageWithoutTouching,
        colors: ['#FF8080', '#FEDD5A', '#7EE4AC', '#80C1FF'],
        categories: kpi.periodsDamageWithoutTouching,
        dataLabelsPosition: 'top',
        dataLabelsTextAchor: 'end',
        height: 90 * kpi.periodsDamageWithoutTouching.length,
      });
      setSettings9({
        hiddenCategorieInLabel: true,
        showYaxis: true,
        data: kpi.totalDamageWithTouching,
        colors: ['#FF8080', '#FEDD5A', '#7EE4AC', '#80C1FF'],
        categories: kpi.periodsDamageWithTouching,
        dataLabelsPosition: 'top',
        dataLabelsTextAchor: 'end',
        height: 90 * kpi.periodsDamageWithTouching.length,
      });
      setSettings10({
        hiddenCategorieInLabel: true,
        showYaxis: true,
        data: kpi.totalDamageFalsePositive,
        colors: ['#FF8080', '#FEDD5A', '#7EE4AC', '#80C1FF'],
        categories: kpi.periodsDamageFalsePositive,
        dataLabelsPosition: 'top',
        dataLabelsTextAchor: 'end',
        height: 90 * kpi.periodsDamageFalsePositive.length,
      });
      setSettings11({
        hiddenCategorieInLabel: true,
        showYaxis: true,
        data: kpi.totalDamageNonDetections,
        colors: ['#FF8080', '#FEDD5A', '#7EE4AC', '#80C1FF'],
        categories: kpi.periodsDamageNonDetections,
        dataLabelsPosition: 'top',
        dataLabelsTextAchor: 'end',
        height: 90 * kpi.periodsDamageNonDetections.length,
      });
      setSettings12({
        hiddenCategorieInLabel: true,
        showYaxis: true,
        data: kpi.totalDamageAttributionErrors,
        colors: ['#FF8080', '#FEDD5A', '#7EE4AC', '#80C1FF'],
        categories: kpi.periodsDamageAttributionErrors,
        dataLabelsPosition: 'top',
        dataLabelsTextAchor: 'end',
        height: 90 * kpi.periodsDamageAttributionErrors.length,
      });
    }
  }, [dataDamage]);

  useEffect(() => {
    const kpi = data?.data;
    if (kpi) {
      setTotalPhotosModerate(kpi.totalPhotosModerate);
      setSettings({
        hiddenCategorieInLabel: true,
        showYaxis: true,
        data: kpi.totalWithoutTouching,
        colors: ['#FF8080', '#FEDD5A', '#7EE4AC', '#80C1FF'],
        categories: kpi.periodsWithoutTouching,
        dataLabelsPosition: 'top',
        dataLabelsTextAchor: 'end',
        height: 90 * kpi.periodsWithoutTouching.length,
      });
      setSettings2({
        hiddenCategorieInLabel: true,
        showYaxis: true,
        data: kpi.totalWithTouching,
        colors: ['#FF8080', '#FEDD5A', '#7EE4AC', '#80C1FF'],
        categories: kpi.periodsWithTouching,
        dataLabelsPosition: 'top',
        dataLabelsTextAchor: 'end',
        height: 90 * kpi.periodsWithTouching.length,
      });
    }
  }, [data]);

  const handleInitAccordion = () => {
    if (
      evolutionKpiGeneriques &&
      evolutionKpiGeneriques.current &&
      evolutionKpiGeneriquesItem &&
      evolutionKpiGeneriquesItem.current
    ) {
      const accordion = KTAccordion.getInstance(evolutionKpiGeneriques.current);
      if (accordion) {
        accordion.show(evolutionKpiGeneriquesItem.current);
      }
    }
  };

  useEffect(() => {
    const currentDate = new Date();
    const currentDay = currentDate.getDay(); // Sunday is 0, Monday is 1, and so on.
    const diffToMonday = currentDay === 0 ? -6 : 1 - currentDay; // Adjust for Sunday being 0
    const mondayDate = new Date(currentDate);
    mondayDate.setDate(currentDate.getDate() + diffToMonday);

    setStartDate(mondayDate);
    setEndDate(currentDate);
  }, []);

  useEffect(() => {
    if (startDate && endDate && groupBy) {
      setFilters({
        startDate: formatDayjsDate(startDate),
        endDate: formatDayjsDate(endDate),
        groupBy,
      });
      setFiltersElement({
        ...filtersElement,
        startDate: formatDayjsDate(startDate),
        endDate: formatDayjsDate(endDate),
      });
      setFiltersDamage({
        ...filtersDamage,
        startDate: formatDayjsDate(startDate),
        endDate: formatDayjsDate(endDate),
      });
      setFiltersElementDamageLink({
        ...filtersElementDamageLink,
        startDate: formatDayjsDate(startDate),
        endDate: formatDayjsDate(endDate),
      });
    } else {
      setFilters(initialKpiFilterRequest);
      setFiltersElement({
        ...filtersElement,
        ...initialKpiFilterRequest,
      });
      setFiltersElement({
        ...filtersDamage,
        ...initialKpiFilterRequest,
      });
      setFiltersElementDamageLink({
        ...filtersElementDamageLink,
        ...initialKpiFilterRequest,
      });
    }
  }, [startDate, endDate, groupBy]);

  return (
    <>
      <div>
        <div className="card">
          <div className="card-body">
            <div className="flex gap-6 items-center justify-center">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-2">
                  <div className="text-2sm text-gray-700 font-medium">
                    {t('common:from')}
                  </div>
                  <DateTimePicker
                    useTime={false}
                    allowClear={false}
                    value={dayjs(startDate)}
                    onChange={(value) => setStartDate(value.toDate())}
                    disablePast={false}
                    numberOfAllowedFutureDays={0}
                    maxDate={dayjs(endDate)}
                  />
                </div>
                <div className="flex items-center gap-2">
                  <div className="text-2sm text-gray-700 font-medium ml-2">
                    {t('common:to').toLowerCase()}
                  </div>
                  <DateTimePicker
                    useTime={false}
                    allowClear={false}
                    value={dayjs(endDate)}
                    onChange={(value) => setEndDate(value.toDate())}
                    disablePast={false}
                    numberOfAllowedFutureDays={1}
                    minDate={dayjs(startDate)}
                  />
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="text-2sm text-gray-700 font-medium">
                  {t('common:granularity')}
                </div>
                <select
                  className="select min-w-[100px] bg-white"
                  name="select"
                  onChange={(e) => setGroupBy(e.target.value)}
                >
                  <option value="month">{t('common:month')}</option>
                  <option value="week">{t('common:week')}</option>
                  <option value="day">{t('common:day')}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div
          className="flex flex-col gap-5 mt-5"
          data-accordion="true"
          ref={evolutionKpiGeneriques}
        >
          <div
            className="accordion-item border rounded-xl"
            data-accordion-item="true"
            id="evolution_kpi_generiquesItem"
            ref={evolutionKpiGeneriquesItem}
          >
            <button
              className="accordion-toggle p-4 bg-primary text-white rounded-xl"
              data-accordion-toggle="#evolution_kpi_generiques_content"
            >
              <span className="text-base text-gray-900 text-white">
                {t('genericKPIsEvolutions')}
              </span>
              <i className="ki-outline ki-plus text-gray-600 text-2sm text-white accordion-active:hidden block"></i>
              <i className="ki-outline ki-minus text-gray-600 text-2sm text-white accordion-active:block hidden"></i>
            </button>
            <div
              className="accordion-content hidden border-t p-4 bg-white"
              id="evolution_kpi_generiques_content"
            >
              <ChartBarKPI
                settings={settings}
                title={t('kpiEvoNbOfImagesWithoutRetouch')}
                subTitle={`${totalPhotosModerate} ${moderatedPhotosText}`}
              />
              <ChartBarKPI
                settings={settings2}
                title={t('kpiEvoNbOfImagesWithRetouch')}
                subTitle={`${totalPhotosModerate} ${moderatedPhotosText}`}
              />
            </div>
          </div>
          <div
            className="accordion-item border rounded-xl"
            data-accordion-item="true"
            id="evolutions_kpi_lies_elements"
          >
            <button
              className="accordion-toggle p-4 bg-primary text-white rounded-xl"
              data-accordion-toggle="#evolutions_kpi_lies_elements_content"
            >
              <span className="text-base text-gray-900 text-white">
                {t('kpiEvoRelatedToEquipments')}
              </span>
              <i className="ki-outline ki-plus text-gray-600 text-2sm text-white accordion-active:hidden block"></i>
              <i className="ki-outline ki-minus text-gray-600 text-2sm text-white accordion-active:block hidden"></i>
            </button>
            <div
              className="accordion-content hidden border-top bg-white"
              id="evolutions_kpi_lies_elements_content"
            >
              <div className="p-4">
                <Select
                  containerClassName="mb-2 w-64 ml-auto"
                  selectClassName="bg-white"
                  placeholder={t('common:chooseAnEquipment')}
                  options={optionElements}
                  onChange={(e) => setValueElement(e.target.value)}
                  defaultValue={'-1'}
                />
                <ChartBarKPI
                  settings={settings3}
                  title={t('kpiEvoNbOfImagesWithoutRetouchForEquipments')}
                  subTitle={`${totalPhotosModerate} ${moderatedPhotosText}`}
                />
                <ChartBarKPI
                  settings={settings4}
                  title={t('kpiEvoNbOfImagesWithRetouchForEquipments')}
                  subTitle={`${totalPhotosModerate} ${moderatedPhotosText}`}
                />
                <ChartBarKPI
                  settings={settings5}
                  title={t('kpiEvoNbOfFauxPositives')}
                  subTitle={`${totalPhotosModerate} ${moderatedPhotosText}`}
                />
                <ChartBarKPI
                  settings={settings6}
                  title={t('kpiEvoNbOfNonDetections')}
                  subTitle={`${totalPhotosModerate} ${moderatedPhotosText}`}
                />
                <ChartBarKPI
                  settings={settings7}
                  title={t('kpiEvoEquipmentNbOfAttributionErrors')}
                  subTitle={`${totalPhotosModerate} ${moderatedPhotosText}`}
                />
              </div>
            </div>
          </div>
          <div
            className="accordion-item border rounded-xl"
            data-accordion-item="true"
            id="evolutions_kpi_lies_dommages"
          >
            <button
              className="accordion-toggle p-4 bg-primary text-white rounded-xl"
              data-accordion-toggle="#evolutions_kpi_lies_dommages_content"
            >
              <span className="text-base text-gray-900 text-white">
                {t('kpiEvoRelatedToDamages')}
              </span>
              <i className="ki-outline ki-plus text-gray-600 text-2sm text-white accordion-active:hidden block"></i>
              <i className="ki-outline ki-minus text-gray-600 text-2sm text-white accordion-active:block hidden"></i>
            </button>
            <div
              className="accordion-content hidden border-t p-4 bg-white"
              id="evolutions_kpi_lies_dommages_content"
            >
              <div>
                <Select
                  containerClassName="mb-2 w-64 ml-auto"
                  selectClassName="bg-white"
                  placeholder={t('common:chooseADamage')}
                  options={optionsDmgList}
                  onChange={(e) => setValueDamage(e.target.value)}
                  defaultValue={'-1'}
                />
                <ChartBarKPI
                  settings={settings8}
                  title={t('kpiEvoNbOfImagesWithoutRetouchForDamages')}
                  subTitle={`${totalPhotosModerate} ${moderatedPhotosText}`}
                />
                <ChartBarKPI
                  settings={settings9}
                  title={t('kpiEvoNbOfImagesWithRetouchForDamages')}
                  subTitle={`${totalPhotosModerate} ${moderatedPhotosText}`}
                />
                <ChartBarKPI
                  settings={settings10}
                  title={t('kpiEvoDamageNbOfFalsePositives')}
                  subTitle={`${totalPhotosModerate} ${moderatedPhotosText}`}
                />
                <ChartBarKPI
                  settings={settings11}
                  title={t('kpiEvoDamageNbOfNonDetections')}
                  subTitle={`${totalPhotosModerate} ${moderatedPhotosText}`}
                />
                <ChartBarKPI
                  settings={settings12}
                  title={t('kpiEvoDamageNbOfAttributionErrors')}
                  subTitle={`${totalPhotosModerate} ${moderatedPhotosText}`}
                />
              </div>
            </div>
          </div>
          <div
            className="accordion-item border rounded-xl"
            data-accordion-item="true"
            id="evolutions_kpi_lies_element_dommages"
          >
            <button
              className="accordion-toggle p-4 bg-primary text-white rounded-xl"
              data-accordion-toggle="#evolutions_kpi_lies_element_dommages_content"
            >
              <span className="text-base text-gray-900 text-white">
                {t('kpiEvoRelatedToEquipmentDamageLink')}
              </span>
              <i className="ki-outline ki-plus text-gray-600 text-2sm text-white accordion-active:hidden block"></i>
              <i className="ki-outline ki-minus text-gray-600 text-2sm text-white accordion-active:block hidden"></i>
            </button>
            <div
              className="accordion-content hidden border-t p-4 bg-white"
              id="evolutions_kpi_lies_element_dommages_content"
            >
              <div>
                <div className="flex gap-4 justify-end">
                  <Select
                    containerClassName="mb-2 w-fit flex-none"
                    selectClassName="bg-white w-64"
                    placeholder={t('common:chooseAnEquipment')}
                    options={optionElements}
                    onChange={(e) => setValueElementLink(e.target.value)}
                    defaultValue={'-1'}
                  />
                  <Select
                    containerClassName="mb-2 w-fit flex-none"
                    selectClassName="bg-white w-64"
                    placeholder={t('common:chooseADamage')}
                    options={optionsDmgList}
                    onChange={(e) => setValueDamageLink(e.target.value)}
                    defaultValue={'-1'}
                  />
                </div>
                <ChartBarKPI
                  settings={settings13}
                  title={t(
                    'kpiEvoNbOfImagesWithoutRetouchForEquipmentDamageLink'
                  )}
                  subTitle={`${totalPhotosModerate} ${moderatedPhotosText}`}
                />
                <ChartBarKPI
                  settings={settings14}
                  title={t('kpiEvoNbOfImagesWithRetouchForEquipmentDamageLink')}
                  subTitle={`${totalPhotosModerate} ${moderatedPhotosText}`}
                />
                <ChartBarKPI
                  settings={settings15}
                  title={t('kpiEvoNbOfNonDetectionsForEquipmentDamageLink')}
                  subTitle={`${totalPhotosModerate} ${moderatedPhotosText}`}
                />
                <ChartBarKPI
                  settings={settings16}
                  title={t('kpiEvoNbOfAttributionErrorsForEquipmentDamageLink')}
                  subTitle={`${totalPhotosModerate} ${moderatedPhotosText}`}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && <Loader />}
    </>
  );
}
